import { ChevronRight, Users, Award, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';

function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-16 md:mb-0 animate-fadeInLeft">
          <img
            src="https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
            alt="Professional business handshake at an airport lounge"
            className="rounded-2xl shadow-elevated"
            loading="lazy"
          />
            <div className="bg-black text-white p-6 rounded-xl shadow-elevated -mt-16 ml-8 md:ml-16 relative z-10 animate-fadeIn max-w-[220px]">
              <div className="flex items-center">
                <span className="text-5xl font-heading font-bold text-[#73BDF2]">5</span>
                <div className="ml-3">
                  <p className="text-xs text-white/60 uppercase tracking-widest">Years Of</p>
                  <p className="font-bold">Experience</p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 md:pl-16 animate-fadeInRight">
            <p className="eyebrow mb-3">About Us</p>
            <h2 className="section-title mb-6">
              REDEFINING YOUR AIRPORT EXPERIENCE
            </h2>
            <p className="mb-6 text-gray-600 leading-relaxed">
              At Moreflex Aviation, <Link to="/about" className="text-[#73BDF2] hover:underline">we understand the stress that comes with
              travel.</Link> That's why we offer Airport Premium Support Assistance,
              ensuring your journey is smooth, comfortable, and hassle-free
              from arrival to departure.
            </p>
            <div className="space-y-5">
              <div className="flex items-start">
                <div className="bg-[#73BDF2]/10 p-2.5 rounded-full mr-4">
                  <Users className="text-[#73BDF2]" size={20} />
                </div>
                <div>
                  <h3 className="font-heading font-bold">Personalized Assistance</h3>
                  <p className="text-gray-500 text-sm">
                    Tailored services to meet your specific needs
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#73BDF2]/10 p-2.5 rounded-full mr-4">
                  <Award className="text-[#73BDF2]" size={20} />
                </div>
                <div>
                  <h3 className="font-heading font-bold">Luxury & Comfort</h3>
                  <p className="text-gray-500 text-sm">
                    Premium lounges and exclusive amenities
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#73BDF2]/10 p-2.5 rounded-full mr-4">
                  <Briefcase className="text-[#73BDF2]" size={20} />
                </div>
                <div>
                  <h3 className="font-heading font-bold">Experienced Professionals</h3>
                  <p className="text-gray-500 text-sm">
                    Highly trained staff dedicated to your satisfaction
                  </p>
                </div>
              </div>
            </div>
            <Link to="/about">
              <button className="btn-primary mt-10">
                Learn More <ChevronRight size={18} />
              </button>
            </Link>

          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
